// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1pfhu2gc{margin-block-start:var(--ds-space-100,8px)}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/form/dist/esm/field.compiled.css"],"names":[],"mappings":"AAAA,WAAW,0CAA0C","sourcesContent":["._1pfhu2gc{margin-block-start:var(--ds-space-100,8px)}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
